<div class="container-fluid">
  <div class="stockWrapper">
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10">
        <div class="card">
          <div class="card-body" style="padding: 2px 1px;">
            <h4 style="padding: 0px; margin-left: 25px">Stocks</h4>
            <form #stocks="ngForm">
              <div class="firstColumn col-lg-12" *ngIf="searchPermission === true">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label>Region</label>
                    <select (change)="selectedRegion($event.target.value)" [(ngModel)]="selectedRegionM"
                            class="form-control"
                            data-show-content="true" id="selectedRegionM"
                            name="region">
                      <option selected>Select Region</option>
                      <option *ngFor="let loc of regionData; let i = index"
                              [value]="loc.id"> {{loc.name}} </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label> Country</label>
                    <select (change)="selectedCountry($event.target.value)" [(ngModel)]="selectedCountryM"
                            class="form-control"
                            data-show-content="true" id="selectedCountryM"
                            name="country">
                      <option selected="">Select Country</option>
                      <option *ngFor="let cou of countryData" [value]="cou.id"> {{cou.name}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label> City</label>
                    <select (change)="selectedCity($event.target.value)" [(ngModel)]="selectedCityM"
                            class="form-control" data-show-content="true"
                            id="selectedCityM" name="city">
                      <option selected="">Select City</option>
                      <option *ngFor="let ci of cityData" [value]="ci.id"> {{ci.name}} </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for="type">Type</label>
                    <select (change)="selectedType($event.target.value)" [(ngModel)]="selectedTypeM" class="form-control" data-show-content="true"
                            id="type"
                            name="type">
                      <option selected value="0">Active</option>
                      <option value="1">Consumed</option>
                      <option value="2">Rejected</option>
                    </select>
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>
        <div class="card1" style="margin-top: 10px;">
          <div class="card-body">
            <table class="table table-hover table-bordered" *ngIf="viewPermission === true">
              <thead>
              <tr>
                <th class="col1" colspan="1" rowspan="4">Product Name</th>
                <th class="col2" colspan="1" rowspan="4">Body Parts</th>
                <th class="col3" colspan="1" rowspan="4">Implant</th>
              </tr>
              <tr *ngIf="stockFlag">
                <th [attr.colspan]="stockLength" class="col7" rowspan="1">
                  {{stocksFrmAPILoc.location}}
                </th>
              </tr>
              <tr>
                <th *ngFor="let st of stocksFrmAPILoc?.stores" class="col8" colspan="1" rowspan="3">{{st.name}}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                (click)="selectRow(i)"
                *ngFor="let stocks of stocksFrmAPI | slice: 0:10| paginate: { id: 'stockPageId', itemsPerPage: per_page, currentPage: current_page, totalItems: total_count}; let i = index "
                [ngClass]="{'sel': i === selectedIndex }" style="height: 36px;">
                <td class="col4">{{stocks.product_name}}</td>
                <td class="col5">{{stocks.body_part_name}}</td>
                <td class="col6">{{stocks.implant_name}}</td>
                <td *ngFor="let st of stocks.stockData" class="col10">{{st.stock}}</td>

              </tr>
              </tbody>

            </table>
          </div>

          <div class="footerWrapper row">
              <div class="col-lg-7 col-md-12 col-sm-12">
                <div class="input-group">
                  <select name="searchBy" [(ngModel)]="searchBy" data-show-content="true"
                   class="form-control border" (change)="getSearchValue()">
                   <option [ngValue]="{field: 'products.name', type: 'str', value:'0'}" name="productNoName" value="0">
                    Search by Product Name
                  </option>
                  <option [ngValue]="{field: 'body_parts.name', type: 'str', value:'1'}" name="bodyNoName"> Search by
                    Body Part
                  </option>
                  <option [ngValue]="{field: 'implants.name', type: 'str', value:'2'}" name="implantNoName"> Search by
                    Implant Type
                  </option>
                </select>
               <input type="text" placeholder="Search" class="form-control" name="searchTxt" [(ngModel)]="searchTxt" [placeholder]="placeHolder">
                  <span class="input-group-text" (click)="doSearch()">
                      <i class="fa fa-search" aria-hidden="true"></i>
                  </span>
                  <span class="input-group-text" (click)="doRefresh()">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
              <div class="col-lg-5 col-md-12 col-sm-12">
                <app-common-page [id]="stockPageId" (pageChange)="doPaginate($event)">
                </app-common-page>
              </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>
